// extracted by mini-css-extract-plugin
module.exports = {"main":"Table2_main__1RFi-","headertxt":"Table2_headertxt__1Y_If","list":"Table2_list__2yywS","firstItemBold":"Table2_firstItemBold__UkbWE","link":"Table2_link__1-20U"};